"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapCreationInfo = exports.SnapCreationInfo_FilterCarouselEntryDirection = void 0;
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
var SnapCreationInfo_FilterCarouselEntryDirection;
(function (SnapCreationInfo_FilterCarouselEntryDirection) {
    SnapCreationInfo_FilterCarouselEntryDirection[SnapCreationInfo_FilterCarouselEntryDirection["UNKNOWN_FILTER_CAROUSEL_ENTRY_DIRECTION"] = 0] = "UNKNOWN_FILTER_CAROUSEL_ENTRY_DIRECTION";
    SnapCreationInfo_FilterCarouselEntryDirection[SnapCreationInfo_FilterCarouselEntryDirection["NONE"] = 1] = "NONE";
    SnapCreationInfo_FilterCarouselEntryDirection[SnapCreationInfo_FilterCarouselEntryDirection["LEFT"] = 2] = "LEFT";
    SnapCreationInfo_FilterCarouselEntryDirection[SnapCreationInfo_FilterCarouselEntryDirection["RIGHT"] = 3] = "RIGHT";
    SnapCreationInfo_FilterCarouselEntryDirection[SnapCreationInfo_FilterCarouselEntryDirection["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SnapCreationInfo_FilterCarouselEntryDirection = exports.SnapCreationInfo_FilterCarouselEntryDirection || (exports.SnapCreationInfo_FilterCarouselEntryDirection = {}));
function createBaseSnapCreationInfo() {
    return {
        camera: undefined,
        isAudioOn: undefined,
        mediaType: 0,
        snapDurationMillis: undefined,
        snapPreviewMillis: undefined,
        geofilterLoadedCount: undefined,
        filterCarouselEntryDirection: 0,
        filterSwipeCount: undefined,
    };
}
exports.SnapCreationInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.camera !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.camera }, writer.uint32(10).fork()).ldelim();
        }
        if (message.isAudioOn !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isAudioOn }, writer.uint32(18).fork()).ldelim();
        }
        if (message.mediaType !== 0) {
            writer.uint32(24).int32(message.mediaType);
        }
        if (message.snapDurationMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.snapDurationMillis }, writer.uint32(34).fork()).ldelim();
        }
        if (message.snapPreviewMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.snapPreviewMillis }, writer.uint32(42).fork()).ldelim();
        }
        if (message.geofilterLoadedCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.geofilterLoadedCount }, writer.uint32(50).fork()).ldelim();
        }
        if (message.filterCarouselEntryDirection !== 0) {
            writer.uint32(56).int32(message.filterCarouselEntryDirection);
        }
        if (message.filterSwipeCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.filterSwipeCount }, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSnapCreationInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.camera = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.isAudioOn = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.mediaType = reader.int32();
                    break;
                case 4:
                    message.snapDurationMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.snapPreviewMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.geofilterLoadedCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.filterCarouselEntryDirection = reader.int32();
                    break;
                case 8:
                    message.filterSwipeCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSnapCreationInfo();
        message.camera = object.camera ?? undefined;
        message.isAudioOn = object.isAudioOn ?? undefined;
        message.mediaType = object.mediaType ?? 0;
        message.snapDurationMillis = object.snapDurationMillis ?? undefined;
        message.snapPreviewMillis = object.snapPreviewMillis ?? undefined;
        message.geofilterLoadedCount = object.geofilterLoadedCount ?? undefined;
        message.filterCarouselEntryDirection =
            object.filterCarouselEntryDirection ?? 0;
        message.filterSwipeCount = object.filterSwipeCount ?? undefined;
        return message;
    },
};
//# sourceMappingURL=snap_creation_info.js.map